<template>
  <div class="corporate-container">
    <top-nav :shrinked="true"/>
    <img class="banner page-banner" src="@/assets/corporate/banner.jpg">
    <div class="site-text-content">
      <h3 style="text-align:center;margin-bottom: 30px;" data-aos="fade-up" data-aos-delay="100" data-aos-once="true">
        让理想照亮生活
      </h3>
      <div class="site-text-desc" data-aos="fade-up" data-aos-delay="200" data-aos-once="true">
        “让理想照亮生活”，立足企业文化视角，回顾嘉宏集团近26年来的历史积淀与探索追求，凝练薪火相承的文化品格，并以企业使命、核心价值观、经营理念、发展理念、人才理念、管理理念、权责理念七大维度，深耕嘉宏集团企业文化理念的根与魂。
      </div>
    </div>
    <div class="VehicleSlider_vehicleSliderWrapper__GnfuV" data-aos="fade-up" data-aos-delay="200" data-aos-once="true" style="max-height: 1254px;">
      <div class="VehicleSlider_vehicleSliderInnerWrapper__UOqKE VehicleSlider_inView__XTMDy">
        <p :class="{'VehicleSlider_inView__XTMDy':isMobile}" class="VehicleSlider_description__X5kLf VehicleSlider_vehicleSliderDescription__q6TV0">
          左右滑动查看更多
        </p>
        <div class="Carousel_carousel__rSN5L carousel" id="vehicle-slider">
          <div class="slider1 VehicleSlider_vehicleSlider__f1Hi3" dir="ltr">
            <div v-for="(item,index) in vehicles" :key="index">
              <div class="VehicleSlider_vehicleSliderItem__SIbRI" >
                <picture class="responsive-image--picture">
                  <source :srcset="require('@/assets/corporate/' + item.image.desktop)" media="(max-width: 1023px)">
                  <img :src="require('@/assets/corporate/' + item.image.desktop)" class="ResponsiveImage_responsiveImage__OVw0A slider-img" draggable="false">
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-content">
      <h3 style="text-align:center;margin-bottom: 30px;">文化活动</h3>
      <div class="grid-bg">
        <div v-for="(item,index) in cultureList" :key="index" class="grid-item" data-aos="fade-up" :data-aos-delay="index*100" data-aos-once="true" @click="toDetails(item,index)">
          <img :src="item.coverImage" @error="onImageError"/>
          <div class="mask"></div>
          <div class="tip ellipsis">{{item.title}}</div>
        </div>
      </div>
      <a class="
          more-btn
          more-btn-text
          more-btn-border
          more-btn-margin"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-once="true"
          type="button" href="javascript:" @click="lookMore">了解更多</a>
    </div>
  </div>
</template>


<script>
import topNav from '@/components/base/top-nav'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';
import {fetchSix} from '@/api/corporate.js';
import {formatUrl} from '@/utils';
import errorImg from '@/assets/error.jpg';
export default {
  name: "corporate",
  components:{
    topNav
  },
  data() {
    return {
      isMobile: false,
      lastScrollTop: 0, // 记录上次滚动位置
      vehicles:[
        {
          "image": {
            "desktop": "slider1.jpg",
            "mobile": "slider1.jpg"
          }
        },
        {
          "image": {
            "desktop": "slider2.jpg",
            "mobile": "slider2.jpg"
          }
        },
        {
          "image": {
            "desktop": "slider3.jpg",
            "mobile": "slider3.jpg"
          }
        },
        {
          "image": {
            "desktop": "slider4.jpg",
            "mobile": "slider4.jpg"
          }
        },
        {
          "image": {
            "desktop": "slider5.jpg",
            "mobile": "slider5.jpg"
          }
        },
        {
          "image": {
            "desktop": "slider6.jpg",
            "mobile": "slider6.jpg"
          }
        },
        {
          "image": {
            "desktop": "slider7.jpg",
            "mobile": "slider7.jpg"
          }
        }
      ],
      cultureList:[
        {
          image:'',
          tip:''
        },{
          image:'',
          tip:''
        },{
          image:'',
          tip:''
        },{
          image:'',
          tip:''
        },{
          image:'',
          tip:''
        },{
          image:'',
          tip:''
        }
      ]
    }
  },
  watch: {
    MobileVerification: {
      handler(to) {
        //处理函数
        this.isMobile = to;
      },
      immediate: true,
    },
  },
  mounted() {
    this.initSlider();
    this.fetchSixList()
  },
  methods: {
    onImageError(event){
      event.target.src = errorImg;
    },
    fetchSixList(){
      fetchSix().then(res=>{
        res.data.forEach(record=>{
          if(record.coverImage){
            record.coverImage = formatUrl(record.coverImage)
          }else{
            record.coverImage = ''
          }
        })
        this.cultureList = res.data
      })
    },
    /**
     * 初始化轮播
     */
    initSlider() {
      this.$nextTick(() => {
        $('.slider1').slick({
          arrows: true,
          initialSlide: 0
        });
      });
    },
    /**
     * 轮播切换
     * @param index
     */
    pagination1Click(index){
      $('.slider1').slick('slickGoTo', index);
    },
    /**
     * 详情页
     */
    toDetails(item,index){
      const routeData = this.$router.resolve({
        path: '/corpdetail', // 假设已经定义了名为NewPage的路由
        query: {
          id: item.id
        }
      });
      window.open(routeData.href, '_blank');
    },
    lookMore() {
      this.$router.push({
        path:'/corplist'
      })
    }
  }
}
</script>

<style>
  @import "../../styles/corporate.css";
</style>
